import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import { hasNewRecord } from "@/api/basicApi";

Vue.use(Vuex);

const state = {
  slideList: JSON.parse(localStorage.getItem("SideBarMenu")),
  // 改变表格的页数或当前页改变数据
  handleSize: 10,
  handleCurrent: 1,
  cardShow: true,
  exportFileStatus: false // 导出文件是否已读
};
const actions = {
  slideListChange(context, value) {
    context.commit("slideListChange", value);
  },
  changeHandleSize(context, value) {
    context.commit("changeHandleSize", value);
  },
  changeHandleCurrent(contet, value) {
    contet.commit("changeHandleCurrent", value);
  },
  cardShow(context, value) {
    context.commit("cardShow", value);
  },
  // 设置是否存在导出记录
  setExportRecord(context, value) {
    context.commit("setExportFileStatus", value);
  },
  /**
   * 公共查询导出文件是否已读状态
   * @value { Number } 1:查询是否存在导出记录未读 2:导出记录已读 3: 登录成功后查询
   * */
  async getExportFileStatus({ commit, dispatch },  value = 1) {
    const res = await hasNewRecord(value);
    console.log('查询导入日志》', res)
    if (res.code === 0) {
      // vuex中存储导出记录状态
      commit("setExportFileStatus", res.data)
      if (!res.data && value === 1) {
        setTimeout(() => {
          dispatch('getExportFileStatus');
        }, 5000)
      }
    }

  }
};
const mutations = {
  slideListChange(state, value) {
    state.slideList = value;
  },
  changeHandleSize(state, value) {
    state.handleSize = value;
    console.log(state.handleSize);
  },
  changeHandleCurrent(state, value) {
    state.handleCurrent = value;
    console.log(state.handleCurrent);
  },
  cardShow(state, value) {
    let show = value;
    state.cardShow = show;
  },
  // 设置是否存在导出记录 value: true执行循环调用 false不执行
  async setExportFileStatus(state, value = false) {
    state.exportFileStatus = value;
  }
};
const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});

export default store;
